import type { ResourceProps } from '@refinedev/core'
import { i18n } from '../../shared/i18n'

export const dashboardResource: ResourceProps = {
  name: 'dashboard',
  list: '/',
  meta: {
    label: i18n.t('navigation.dashboard'),
  },
}
